require('./agentLoginView.scss');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

//@components
const { AgentLogin } = require('components/disasterRecovery/agentLogin/agentLogin');

// @ actions
const agentAuthentication = require('actions/contactCenter/agentAuthentication/agentAuthentication');
const translations = require('actions/translations');

class AgentLoginView extends React.Component {

    render() {
        return (
            <div className="agent-login-view">
                <AgentLogin
                    {...this.props}
                />
            </div>
        );
    }
}

AgentLoginView.propTypes = {
    immAgentLogin: PropTypes.object.isRequired,
    immTranslations: PropTypes.object.isRequired,
    requestAgentCredentials: PropTypes.func.isRequired,
    requestTranslations: PropTypes.func.isRequired
};

module.exports.AgentLoginView = connect(
    state => ({
        immAgentLogin: state.agentAuthentication,
        immTranslations: state.translations
    }), ({
        requestAgentCredentials: agentAuthentication.agentLoginRequest,
        requestTranslations: translations.requestTranslations

    })
)(AgentLoginView);
